import { BRAND, images } from '../data';

export default function Wordmark({ className = '', inverted = false }) {
  return (
    <a
      className={`wordmark${inverted ? ' is-inverted' : ''} ${className}`.trim()}
      href="#top"
      aria-label={`${BRAND} — home`}
    >
      <img
        className="wordmark-lockup"
        src={inverted ? images.logoOnDark : images.logo}
        alt=""
      />
    </a>
  );
}
